<div class="container-fluid mb-3">
    <div class="row">
        <div class="col-12 col-sm-6 p-0">
            {{ i18n._803_NAME_ | translate }} {{ user.username }}
        </div>
        <div class="col-12 col-sm-6 p-0 text-sm-right">
            {{ i18n._804_SUPERGROUP_ | translate }}
            {{ user.superGroupName }}
        </div>
    </div>
</div>
<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div
    class="text-center"
    *ngIf="!hasPendingData && data == null"
>
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<ngb-tabset
    [activeId]="activeTabId"
    *ngIf="!hasPendingData && data != null"
>
    <ng-template
        ngFor
        let-i
        let-ii="index"
        [ngForOf]="data.items"
    >
        <ngb-tab [id]="'w-tab-' + ii">
            <ng-template ngbTabTitle>{{ i.name }}</ng-template>
            <ng-template ngbTabContent>
                <ng-template
                    ngFor
                    let-j
                    let-jj="index"
                    [ngForOf]="i.categories"
                >
                    <div class="table-responsive">
                        <table
                            class="table table-striped table-sm table-bordered cmps-widget-table"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th
                                        class="text-center"
                                        colspan="2"
                                    >
                                        {{ j.name }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="w-25">
                                        <strong>{{
                                            i18n._805_OPP__ | translate
                                        }}</strong>
                                    </td>
                                    <td class="text-center">
                                        <strong
                                            >{{ i18n._806_SCORE_ | translate }}
                                            <span
                                                [ngStyle]="{
                                                    color: j.scoreColor
                                                }"
                                                >{{
                                                    j.score == null
                                                        ? (i18n._842_N_A
                                                          | translate)
                                                        : (j.score
                                                          | percent: '1.1-1')
                                                }}</span
                                            ></strong
                                        >
                                    </td>
                                </tr>
                                <ng-container
                                    *ngIf="j.opps?.length !== 0; else noDataTpl"
                                >
                                    <ng-template
                                        ngFor
                                        let-k
                                        let-kk="index"
                                        [ngForOf]="j.opps"
                                    >
                                        <tr>
                                            <td>{{ kk + 1 }}</td>
                                            <td class="text-center">
                                                {{
                                                    k.name ||
                                                        (i18n._842_N_A
                                                            | translate)
                                                }}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </ng-template>
        </ngb-tab>
    </ng-template>
</ngb-tabset>

<ng-template #noDataTpl>
    <tr>
        <td
            class="text-center"
            colspan="2"
        >
            {{ i18n._711_NO_DATA_AVAILABLE | translate }}
        </td>
    </tr>
</ng-template>
